import { useLocation } from 'react-router-dom';

function useCheckoutPath() {
	const location = useLocation();
	const pathSegments = location.pathname.split('/');
	const lastSegment = pathSegments[pathSegments.length - 1]?.toLowerCase();

	const isSimplified = lastSegment === 'simplifiedcheckout';

	const pathname = isSimplified ? 'Simplifiedcheckout' : 'Checkout';

	const getCurrentPath = (step: string) => (isSimplified ? 'Simplifiedcheckout' : `checkout ${step}`);

	return {
		pathname,
		getCurrentPath,
	};
}

export default useCheckoutPath;
